import React, { PropsWithChildren, useRef } from "react";
import BackgroundCornerImage from '../../../../assets/background.png';
import { useScroll } from 'react-use';

import { TailSpin } from "../Loader/TailSpin";
import ResourceProgress from "../../../utils/ResourceProgress";

export const ScrollContext = React.createContext<number>(0);

type ScreenContainerProps = {
  loading?: boolean;
  className?: string;
  error?: React.ReactNode;
};

const ScreenContainer: React.FC<PropsWithChildren<ScreenContainerProps>> = ({
  loading = false,
  error,
  className = "",
  children,
}) => {
  const scrollRef = React.useRef(null);
  const { y } = useScroll(scrollRef);

  return (
    <div
      ref={scrollRef}
      className="flex-grow overflow-y-auto bg-fixed bg-white bg-right-bottom bg-no-repeat text-dark-100 pb-20"
      style={{
        backgroundImage: `url(${BackgroundCornerImage})`
      }}
    >
      <ResourceProgress
        isLoading={loading}
        isEmpty={false}
      />
      {
        !loading && (
          <ScrollContext.Provider value={y}>
            <div
              className={`min-h-layout ${className}`}
            >
              {error ? error : children}
            </div>
          </ScrollContext.Provider>
        )
      }
    </div>
  );
};

export default React.memo(ScreenContainer);
